var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_24",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.711,
    height: 16.652,
    viewBox: "0 0 18.711 16.652",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_5",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 5",
    d: "M10.861,8.715a.715.715,0,0,1,1.43,0v2.861a.715.715,0,0,1-.715.715H8.715a.715.715,0,0,1,0-1.43h2.146Z",
    transform: "translate(-1.82 -2.703)",
    fill: "#82c43c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_6",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 6",
    d: "M20.711,10.326c0,4.6-4.189,8.326-9.356,8.326S2,14.924,2,10.326,6.189,2,11.356,2,20.711,5.728,20.711,10.326Zm-1.871,0c0,3.679-3.351,6.661-7.485,6.661S3.871,14,3.871,10.326s3.351-6.661,7.485-6.661S18.84,6.647,18.84,10.326Z",
    transform: "translate(-2 -2)",
    fill: "#82c43c",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.ec71e343.svg";
export { ForwardRef as ReactComponent };